import React, { useState, useEffect, useRef } from 'react';

export default function AddressAutocomplete({ value, onChange, onSelect, customerLat, customerLng }) {
  const [query, setQuery] = useState(value || '');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [complement, setComplement] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    setQuery(value || '');
  }, [value]);

  const search = async (q) => {
    if (!q || q.length < 3) { setResults([]); return; }
    setLoading(true);
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q + ', Florianópolis, SC')}&limit=5&accept-language=pt-BR`);
      const data = await res.json();
      setResults(data.map(item => ({
        display_name: item.display_name,
        lat: parseFloat(item.lat),
        lon: parseFloat(item.lon),
        address: {
          road: item.address?.road || '',
          house_number: item.address?.house_number || '',
          suburb: item.address?.suburb || item.address?.neighbourhood || '',
          city: item.address?.city || item.address?.town || 'Florianópolis',
        }
      })));
      setShowResults(true);
    } catch {
      setResults([]);
    } finally { setLoading(false); }
  };

  const handleChange = (e) => {
    const q = e.target.value;
    setQuery(q);
    onChange && onChange(q);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => search(q), 600);
  };

  const handleSelect = (item) => {
    setQuery(item.display_name);
    setShowResults(false);
    onSelect && onSelect({
      fullAddress: item.display_name,
      street: item.address.road,
      number: item.address.house_number,
      neighborhood: item.address.suburb,
      city: item.address.city,
      lat: item.lat,
      lng: item.lon,
      complement: complement,
    });
  };

  return (
    <div className="relative space-y-2">
      <input
        value={query}
        onChange={handleChange}
        placeholder="Digite seu endereço (ex: Rua São José, 123)"
        className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm"
        autoComplete="off"
      />
      {loading && <div className="text-xs text-gray-400">Buscando...</div>}
      {showResults && results.length > 0 && (
        <div className="absolute z-50 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-48 overflow-y-auto">
          {results.map((item, idx) => (
            <button
              key={idx}
              onClick={() => handleSelect(item)}
              className="w-full text-left px-3 py-2 text-xs hover:bg-gray-50 border-b border-gray-100 last:border-0"
            >
              {item.display_name}
            </button>
          ))}
        </div>
      )}
      <input
        value={complement}
        onChange={e => { setComplement(e.target.value); onSelect && onSelect({ complement: e.target.value }); }}
        placeholder="Apto, bloco, fundos, sala... (complemento)"
        className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm"
      />
    </div>
  );
}
